import { render, staticRenderFns } from "./own.vue?vue&type=template&id=356c22a0&scoped=true&"
import script from "./own.vue?vue&type=script&lang=ts&"
export * from "./own.vue?vue&type=script&lang=ts&"
import style0 from "./own.vue?vue&type=style&index=0&id=356c22a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c22a0",
  null
  
)

export default component.exports